import React, { useEffect, useState, useCallback } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMore from "@mui/icons-material/ExpandMore";
import * as Styled from "../styles";
import PropTypes from "prop-types";

const accordionStyles = {
  boxShadow: "none",
  padding: 0,
  minHeight: 0,
  margin: 0,
  // border: "1px solid black",
  // width: "408px",
  width: "360px",
  backgroundColor: "white",
  "&:before": {
    display: "none",
  },
  transition: "all 0.3s ease",
};

const summaryStyles = {
  backgroundColor: "#F6F7F9",
  height: 40,
  padding: "0px !important",
  minHeight: 0,
  borderRadius: "8px",
  border: 1,
  "&.Mui-expanded": {
    minHeight: 0,
    margin: 0,
    padding: 0,
    borderRadius: "8px 8px 0 0",
    height: 40,
    // width: "408px",
    width: "360px",
  },
  "&.Mui-expanded .MuiAccordionSummary-content": {
    margin: 0,
    // width: "408px",
    width: "360px",
  },
};

const detailsStyles = {
  padding: "0",
  backgroundColor: "white",
  margin: "0",
  boxShadow: "0px 0px 9.3px 0px #3B3B3B1C",
};

function DisplayContent({ data, isSelected, onClick }) {
  return (
    <Styled.DropDownListItem
      width="87%"
      style={{
        backgroundColor: isSelected ? "#F7F2FA" : null,
      }}
      onClick={onClick}
    >
      <Styled.DropDownIconDiv>
        {data.icons.map((icon) => (
          <React.Fragment key={icon.id}>{icon?.component}</React.Fragment>
        ))}
      </Styled.DropDownIconDiv>
      <Styled.TextDiv>
        <Styled.DropDownTextStyle>{data?.title}</Styled.DropDownTextStyle>
      </Styled.TextDiv>
    </Styled.DropDownListItem>
  );
}

DisplayContent.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number.isRequired,
    key: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    icons: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        component: PropTypes.element.isRequired,
      })
    ).isRequired,
  }).isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const IconSelect = React.memo(function IconSelect({
  items,
  selectedItemId,
  onItemSelect,
}) {
  const [expanded, setExpanded] = useState(false);

  const handleToggleExpand = useCallback(() => {
    setExpanded((prevExpanded) => !prevExpanded);
  }, []);

  const selectedItem = items?.find((item) => item.id === selectedItemId);

  useEffect(() => {
    setExpanded(false);
  }, [selectedItemId]);

  return (
    <Accordion
      sx={accordionStyles}
      style={{}}
      expanded={expanded}
      onChange={handleToggleExpand}
    >
      <AccordionSummary
        expandIcon={<ExpandMore />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={summaryStyles}
      >
        <Styled.DropDownListItem>
          <Styled.DropDownIconDiv>
            {selectedItem?.icons?.map((icon) => (
              <React.Fragment key={icon.id}>{icon.component}</React.Fragment>
            ))}
          </Styled.DropDownIconDiv>
          <Styled.TextDiv>
            <Styled.DropDownTextStyle>
              {selectedItem?.title}
            </Styled.DropDownTextStyle>
          </Styled.TextDiv>
        </Styled.DropDownListItem>
      </AccordionSummary>
      <AccordionDetails sx={detailsStyles}>
        <Styled.DropDownBody>
          {items.map((item) => (
            <DisplayContent
              key={item.id}
              data={item}
              isSelected={selectedItemId === item.id}
              onClick={() => {
                onItemSelect(item.id);
                setExpanded(false);
              }}
            />
          ))}
        </Styled.DropDownBody>
      </AccordionDetails>
    </Accordion>
  );
});

IconSelect.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      key: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      icons: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.number.isRequired,
          component: PropTypes.element.isRequired,
        })
      ).isRequired,
    })
  ).isRequired,
  selectedItemId: PropTypes.number.isRequired,
  onItemSelect: PropTypes.func.isRequired,
};

export default IconSelect;
